import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { NgbCalendar, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, CommonService, UserService } from 'src/app/services';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject, Subscription, from } from 'rxjs';
import { concatMap, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.scss'],
  encapsulation :ViewEncapsulation.None
})
export class ReleaseNotesComponent implements OnInit {
data = [];
@ViewChild('leftScrollContainer') leftScrollContainer!: ElementRef;
@ViewChildren('monthItem') monthItems!: QueryList<ElementRef>;
@ViewChild("ReleaseNotes",{static: true})
ReleaseNotes : any;
@ViewChild("searchBoxReleaseType", { static: true }) 
searchBoxReleaseType: ElementRef;
@Output() CloseReleaseModal = new EventEmitter<any>();
@Output() CountForRns = new EventEmitter<any>();
ReleasemodelRef: any;
array: any = [];
filteredOptions: any[] = [];
searchTerm = '';
ids = [];
dataforChecked = [];
duplicateArrayRn = [];
searchSelectedData = [];
inputFg : FormGroup;
hasRnData : boolean;
currentDate: Date;
currentMonth: number;
currentYear: any;
months = [];
shortYear: string;
requiredFormat: string;
defaultValue: any;
isFocused : boolean;
userId: string;
userIdInt: number;
unsubscribe$: Subject<void> = new Subject();
jVersion: any;
keyToCheckRelaseNotes : boolean;
releaseBuildVersion: { UserId: number; BuildVersion: string; ShowReleasesAfterLogin : boolean};
selectedValue: any;
isConfluneceServiceNotAvailable : boolean;
subscription = new Subscription();
rnDataToDisplay: any;
idList = [];
isLinkedClicked: boolean;
isFrmSearch : boolean = false;
expandedMonth: string | null = null;
monthBuilds: { [key: string]: any[] } = {};
searchResults: any[] = [];
loadedNotes: any[] = [];
batchSize: number = 5;
currentBatch: number = 0;
loading: boolean = false;
  @HostListener("window:keydown", ["$event"])
  keyEventAlt(event: KeyboardEvent) {
      if (event.which === 27) {
          event.preventDefault();
          this.releaseNotesClose();
      }
  }
  constructor(private _userService:UserService,private _modalService:NgbModal, private _fb:FormBuilder,private _alertSrv :AlertService,private calendar:NgbCalendar,
    private _cmmnServ :CommonService) {
    this.inputFg = this._fb.group({
      inputText : [],
      ShowReleasesAfterLogin : this.keyToCheckRelaseNotes
    });
  }

 ngOnInit(): void {
  this.idList = [];
  this.getReleaseNotesPopup();
  this.getDate();
  this.selectedValue = "New Releases";
  this.expandedMonth = "New Releases";
  this._userService.getReleaseNotesPages({ date: "New Releases" })
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((resp) => {
      if (resp && resp.releaseNotesPages) {
        this.monthBuilds["New Releases"] = resp.releaseNotesPages;
        this.hasRnData = true;
        this.isConfluneceServiceNotAvailable = false;
        // Showing the details of New releases automatically
        if (resp.releaseNotesPages.length > 0) {
          this.getReleaseNotesForBuild(resp.releaseNotesPages[0]);
        }
      } else if (!resp.IsConfluneceServiceAvailable && !resp.releaseNotesPages) {
        this.isConfluneceServiceNotAvailable = true;
        this.monthBuilds["New Releases"] = [];
      } else {
        this.hasRnData = false;
        this.isConfluneceServiceNotAvailable = false;
        this.monthBuilds["New Releases"] = [];
      }
      this.searchSelectedData = resp;
      this.filteredOptions = resp.releaseNotesPages;
      this.keyToCheckRelaseNotes = resp.ShowReleasesAfterLogin;
      this.duplicateArrayRn = [];
      this.idList = [];
      this.array = this.duplicateArrayRn;
    });
}

  getReleaseNotesPopup(){
    this.ReleasemodelRef = this._modalService.open(this.ReleaseNotes,
        { backdrop: false, centered: true, windowClass: "max-wdth_73 release-notes-modal" });
  }

  getDate(){
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      this.currentYear = currentDate.getFullYear();
      for (let i = 0; i <= 12; i++) {
        const date = new Date(this.currentYear, currentMonth - i, 1);
        const monthName = date.toLocaleString('default', { month: 'short' });
        this.shortYear = date.getFullYear().toString();
        this.shortYear = this.shortYear.slice(-2);
        this.requiredFormat = `${monthName} '${this.shortYear}`;
        this.months.push(this.requiredFormat);
        this.defaultValue = this.months[0];
    }
  }

getPagesForReleaseNotes(month: string, frmOnint?: boolean) {
  // Toggle expand/collapse for submenu
  this.searchTerm = '';
  if (month === 'New Releases') {
    this.expandedMonth = 'New Releases';
  } else if (this.expandedMonth === month) {
    this.expandedMonth = null;
    return;
  } else {
    this.expandedMonth = month;
  }
  this.selectedValue = month;
  this.isLinkedClicked = frmOnint ? true : false;
  this.isFrmSearch = false;
  let payload: any;
  if (month === "New Releases") {
    payload = { date: "New Releases" };
  } else {
    const Year = this.currentYear.toString();
    const FullYear = month.replace("'", Year.slice(0,2));
    payload = { date: FullYear };
  }
  this._userService.getReleaseNotesPages(payload)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((resp) => {
      if (resp && resp.releaseNotesPages) {
        this.monthBuilds[month] = resp.releaseNotesPages;
        this.hasRnData = true;
        this.isConfluneceServiceNotAvailable = false;
        this.scrollToExpandedMonth(month);
        // Automatically fetch details for the first build for New Releases
        if (month === "New Releases" && resp.releaseNotesPages.length > 0) {
          this.getReleaseNotesForBuild(resp.releaseNotesPages[0]);
        }
      } else if (!resp.IsConfluneceServiceAvailable && !resp.releaseNotesPages) {
        this.isConfluneceServiceNotAvailable = true;
        this.monthBuilds[month] = [];
      } else {
        this.hasRnData = false;
        this.isConfluneceServiceNotAvailable = false;
        this.monthBuilds[month] = [];
      }
      this.searchSelectedData = resp;
      this.filteredOptions = resp.releaseNotesPages;
      this.keyToCheckRelaseNotes = resp.ShowReleasesAfterLogin;
      this.duplicateArrayRn = [];
      this.idList = [];
      this.array = this.duplicateArrayRn;
    });
}
  scrollToExpandedMonth(month: string) {
    setTimeout(() => {
      const index = this.months.indexOf(month);
      const monthEl = this.monthItems.toArray()[index];
      if (!monthEl) return;

      const container = this.leftScrollContainer.nativeElement;
      const itemTop = monthEl.nativeElement.offsetTop;
      const itemHeight = monthEl.nativeElement.offsetHeight;
      const containerHeight = container.clientHeight;

      container.scrollTo({
        top: itemTop - containerHeight / 2 + itemHeight,
        behavior: 'smooth'
      });
    });
  }
  searchFeatures(event?: any) {
    if (event) {
      if (event.target && event.target.value !== undefined) {
        this.searchTerm = event.target.value;
      } else if (event.value !== undefined) {
        this.searchTerm = event.value;
      } else if (typeof event === 'string') {
        this.searchTerm = event;
      }
    }
    const Year = this.currentYear?.toString() || '';
    const selectedMonth = this.selectedValue || '';
    const FullYear = selectedMonth ? selectedMonth.replace("'", Year.slice(0,2)) : '';
    const payload: any = {
      IsFromSearch: true,
      SearchText:   this.searchTerm,
      date: FullYear
    };
    this._userService.getReleaseNotesPages(payload)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((resp) => {
        if (resp && resp.releaseNotesPages) {
          this.searchResults = resp.releaseNotesPages;
          this.loadedNotes = [];
          this.currentBatch = 0;
          this.hasRnData = false;
          this.isConfluneceServiceNotAvailable = false;
          this.isFrmSearch = true;
          this.loadNextBatch();
        } else {
          this.searchResults = [];
          this.loadedNotes = [];
          this.isFrmSearch = true;
        }
      });
}

loadNextBatch() {
  if (this.loading) return;
  this.loading = true;
  const start = this.currentBatch * this.batchSize;
  const end = start + this.batchSize;
  const batch = this.searchResults?.slice(start, end);
  if (batch?.length === 0) {
    this.loading = false;
    return;
  }
  let promises = batch?.map(item =>
    this._userService.getReleaseNotes(item?.Id).toPromise().then(res => ({
      ...item,
      response: res?.response || ''
    })).catch(error => ({
      ...item,
      response: '',
      error: error
    }))
  );
  Promise.all(promises).then(results => {
    this.loadedNotes = [...this.loadedNotes, ...results];
    this.currentBatch++;
    this.loading = false;
    // If there are more items, keep hasRnData false so spinner can show
    if (this.loadedNotes?.length >= this.searchResults?.length) {
      this.hasRnData = true;
    }
  });
}

onSearchListScroll(event: any) {
  if (this.loadedNotes?.length >= this.searchResults?.length) return; // Stop if all loaded
  const element = event?.target ? event.target : null;
  if (element && element.scrollHeight - element.scrollTop <= element.clientHeight + 50) {
    this.loadNextBatch();
  }
}

highlightElement(element) {
    element.classList.toggle('highlight');
  }
  releaseNotesClose(){
    this.idList = [];
    this.userId = this._userService.getToken("UserId");
    this.userIdInt = parseInt(this.userId)
    this.subscription.add(this._cmmnServ.getAppVersion().subscribe(resp => {
    if (resp && resp.version) {
        this.jVersion = resp.version;
        this.releaseBuildVersion = {
        UserId : this.userIdInt,
        BuildVersion : this.jVersion,
        ShowReleasesAfterLogin : this.inputFg.controls["ShowReleasesAfterLogin"].value
      }
        this._userService.postReleaseNotesBuildVersion(this.releaseBuildVersion)
        .subscribe((res)=>{
        if(res){    
           this.inputFg.controls["ShowReleasesAfterLogin"].patchValue(this.keyToCheckRelaseNotes);
           if(this.subscription){
              this.subscription.unsubscribe();
              this.subscription = new Subscription();
           }
        }});
    }}));
    if(this.ReleasemodelRef){
      this.ReleasemodelRef.close();
      this.ReleasemodelRef = null;
    }
    this.CloseReleaseModal.emit(true);
    this.CountForRns.emit(true);
  }

checkedReleaseCheckbox(isChecked,Id,isMultiple){
  if(this.ids && !this.ids.includes(Id)){
    this.ids.push(Id)
  }
  if(isChecked && this.ids && this.ids.length > 0){
    this.duplicateArrayRn.forEach(x => {
      if(x.Id === Id && isMultiple){
        this.dataforChecked.push(x);
      }
      else if(x && x.Id === Id && !isMultiple){
        this.dataforChecked = [];
        this.dataforChecked.push(x);
      }
    })
    this.dataforChecked.map((item)=>{
      if(item && item.response){
        this.array = [...this.dataforChecked] 
      }
    })
  } else if(!isChecked && this.ids && this.ids.length > 1){
    this.dataforChecked = this.dataforChecked.filter(x => x.Id !== Id);
    this.ids = this.ids.filter(id => id !== Id);
    this.array = [...this.dataforChecked];
  } else{
    if(this.ids.length === 1){
      this.ids = [];
    }
      this.array =[...this.duplicateArrayRn];
      this.dataforChecked = [];
  }
}
searchMenuforReleaseData(event){
  if(event && event.value && event.value['Title']){
    this.array = [];
    this.isFrmSearch = true;
    this.searchTerm = event.value['Title'];
    this.filteredOptions = this.searchSelectedData['releaseNotesPages'].filter(option => option.Title.toLowerCase().includes(this.searchTerm.toLowerCase()));
    this.filteredOptions.map(async (item)=>{
      if(item && this.searchTerm !== "" && item.Title.toLowerCase().startsWith(this.searchTerm.toLowerCase())){
        item.isChecked = true;
        let result = await this._userService.getReleaseNotes(item.Id).toPromise();
        if(result){
          this.array = [result];
        }
        this.isFocused = true;
      } else {
        item.isChecked = false;
      }
    });
  } else {
    this.isFrmSearch = false;
    this.ids = [];
    this.array =[...this.duplicateArrayRn];
  }
  this.filteredOptions = this.searchSelectedData['releaseNotesPages'];
}

showBuildDetails(build: any) {
  this.rnDataToDisplay = build.response;
  this.isFrmSearch = false;
  this.isLinkedClicked = false;
}

clickOnUserGuideLinks() {
	const handler = (event: Event) => {
	if ((event.target as HTMLElement).tagName === 'A') {
    this.isFrmSearch = false;
	  this.isLinkedClicked = true;
    this.rnDataToDisplay = "";
		event.preventDefault();
		const url = (event.target as HTMLAnchorElement).href;
		let id;
		let urlArray = url.split('/');
		urlArray.map((data, i) => {
		if (data == 'pages') {
			id = urlArray[i + 1];
		}
		});
		if (id) {
		this._cmmnServ.getUserGuideDataWithId(id).subscribe(res => {
			if (res.response == "error") {
			this.rnDataToDisplay = `<div class="userGuide-error">
									<p><i class="far fa-exclamation-triangle"></i></p>
									Service Unavailable at the moment. Please re-try in sometime.
								</div>`;
			} else {
			this.rnDataToDisplay = res.response;
			if (this.idList.indexOf(id) === -1) {
				this.idList.push(id);
			}
			}
		});
		}
		
	}
  document.removeEventListener('click', handler);
	};
	document.addEventListener('click', handler);
}
ngOnDestroy() {
  this.unsubscribe$.next();
  this.unsubscribe$.complete();
}
getReleaseNotesForBuild(build: any) {
  this.searchTerm = '';
  this.hasRnData = false;
  this.isConfluneceServiceNotAvailable = false;
  this._userService.getReleaseNotes(build.Id).pipe(takeUntil(this.unsubscribe$)).subscribe(result => {
    if (result && result.response) {
      this.rnDataToDisplay = result.response;
      this.hasRnData = true;
      this.isConfluneceServiceNotAvailable = false;
      this.isFrmSearch = false;
    } else {
      this.rnDataToDisplay = '';
      this.hasRnData = false;
      this.isConfluneceServiceNotAvailable = true;
      this.isFrmSearch = false;
    }
  });
}
}
